import SimpleTable from "@/components/SimpleTable";
import { AppAssessmentProgress } from "@/schema/AssessmentProgress";
import HistoryDropDown from "@/src/console/(auth)/companies/[id]/_components/HistoryCard/HistoryDropDown";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface HistoryTableProps {
  data: AppAssessmentProgress[];
}

function HistoryTable({ data }: HistoryTableProps) {
  const { t } = useTranslation();
  return (
    <SimpleTable
      className="border-x-none border-b-none rounded-t-none shadow-none"
      data={data}
      columns={[
        {
          key: "id",
          label: "ID",
          render: ({ id }) => id,
        },
        {
          key: "status",
          label: t("status"),
          render: ({ status: { name } }) => name,
        },
        {
          key: "updated-at",
          label: t("updated-at"),
          render: ({ updated_at }) => format(updated_at, t("date-format")),
        },
        {
          width: "200px",
          key: "action",
          label: "",
          render: ({
            id,
            has_first_evaluation_report,
            has_improvement_proposal,
            has_second_evaluation_report,
          }) => (
            <HistoryDropDown
              id={id}
              hasFirstEvaluationReport={has_first_evaluation_report}
              hasSecondEvaluationReport={has_second_evaluation_report}
              hasImprovementProposal={has_improvement_proposal}
            />
          ),
        },
      ]}
    />
  );
}

export default HistoryTable;
